import * as React from "react";
const SvgTurnSlightLeft = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.66 6V4H6v5.66h2V7.41l5 5V20h2v-8.41L9.41 6z",
  fill: "currentColor"
}));
export default SvgTurnSlightLeft;